// @flow
import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'
import type { AppStateType } from '@reducers/appstate'
import { useSelector } from 'react-redux'
import type { UserListenType } from '../../flowTypes'

type ComponentPropsType = {
  completed?: boolean,
  position: number,
  duration: number
}

export function PlayIndicatorComponent (props: ComponentPropsType): React.Node {
  return (
    <PlayIndicatorContainer>
      {(!props.completed && props.position !== 0) && <ProgressBar $position={props.position} $duration={props.duration}/>}
      {props.completed && <TagPillButton>Played</TagPillButton>}
    </PlayIndicatorContainer>
  )
}

type PropsType = {
  trackId: string,
  duration: number
}
export default function PlayIndicator (props: PropsType): React.Node {
  const listen = useSelector((state: AppStateType): ?UserListenType => {
    return state.user?.listens?.[props.trackId]
  })
  if (listen) {
    const newProps = {
      position: listen.furthest_position,
      duration: props.duration,
      completed: listen.completed
    }
    return <PlayIndicatorComponent {...newProps}/>
  }
  return null
}

export const TagPillButton = styled.div`
  font-family: "Good Sans Regular";
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px; /* 136.364% */
  letter-spacing: -0.3px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  color: ${colors.white};
  border-radius: 100px;
  border: 1px solid ${colors.white};
  max-width: 66px;
    span {
        margin-right: 4px;
    }
`

const ProgressBar = styled.div`
    width: 100%;
    height: 6px;
    border-radius: 3px;
    background: ${(props: any): string => {
        const progress = (props.$position / props.$duration) * 100
        return `linear-gradient(to right, ${colors.white} ${progress}%, ${colors.white50} ${progress}%)`
    }};
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
const PlayIndicatorContainer = styled.div`
    display: flex;
    width: 100%;
    
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
